import { Flex, Logo, Typography } from '@percent/lemonade'

import styles from './Footer.module.scss'
import { Link } from 'react-router-dom'
import { FooterProps } from './Footer.types'
export const DEFAULT_GOODSTACK_URL = 'https://goodstack.org/'
export const PRIVACY_POLICY_URL = 'https://goodstack.org/legal/privacy-policy'
export const TERMS_URL = 'https://goodstack.org/legal/applicant-validation-terms'

const FooterLink = ({ children, to }: { children: React.ReactNode; to: string }) => {
  return (
    <Link to={to} className={styles.footerLink} target="_blank" rel="noopener noreferrer">
      <Typography className={styles.termsPrivacy}>{children}</Typography>
    </Link>
  )
}

export const Footer = ({ termsLabel, privacyLabel, poweredByUrl = DEFAULT_GOODSTACK_URL }: FooterProps) => {
  return (
    <Flex className={styles.footerWrapper}>
      <Flex align="center" gap={8}>
        <Typography className={styles.poweredBy}>
          {/* We want to keep this without translation */}
          Powered by
        </Typography>
        <Link to={poweredByUrl} target="_blank" rel="noopener noreferrer">
          <Logo className={styles.logo} />
        </Link>
      </Flex>
      <Flex align="center" gap={4}>
        <FooterLink to={TERMS_URL}>{termsLabel}</FooterLink>
        <Typography className={styles.termsPrivacy}>•</Typography>
        <FooterLink to={PRIVACY_POLICY_URL}>{privacyLabel}</FooterLink>
      </Flex>
    </Flex>
  )
}
